export const INITIAL = {
  SANDBOX_AREA: { W: 0, H: 0 },
}
